<template>
  <button @click="$emit('click')" type="button" class="items-center px-4 py-2 border border-transparent text-base font-medium
  rounded-md shadow-sm text-white bg-brand-dark
  focus:ring-indigo-500" v-html="text">

  </button>
</template>

<script>
import buttonMixin from "@/components/Functional/Buttons/buttonMixin";

export default {
  name: "SecondaryButton",
  mixins: [buttonMixin]
}
</script>

<style scoped>

</style>